import { fmtMoney } from "../../parsers/xmlParser";

export default function KisuimMigdalTab({ fund, cs }) {
  const kisuim = fund.kisuimMigdal || [];
  if (!kisuim.length) {
    return <div style={{ color: "#94a3b8", fontSize: 13 }}>אין כיסויים בפוליסה זו.</div>;
  }

  const totalMonthly = kisuim.reduce((s, k) => s + (k.premiumMonthly || 0), 0);
  const hasValues    = kisuim.some(k => k.value > 0);
  const hasDates     = kisuim.some(k => k.startDate || k.endDate);

  const th = {
    padding: "5px 10px", fontSize: 11, fontWeight: 700,
    color: "#64748b", borderBottom: "2px solid #e2e8f0",
    textAlign: "right", whiteSpace: "nowrap", background: "#f8fafc",
  };
  const td = (extra = {}) => ({
    padding: "5px 10px", fontSize: 12, color: "#0f172a",
    borderBottom: "1px solid #f1f5f9", verticalAlign: "middle", ...extra,
  });

  return (
    <div>
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", direction: "rtl" }}>
          <thead>
            <tr>
              <th style={th}>כיסוי</th>
              <th style={{ ...th, textAlign: "center" }}>סטטוס</th>
              {hasValues && <th style={{ ...th, textAlign: "left" }}>סכום ביטוח</th>}
              <th style={{ ...th, textAlign: "left" }}>פרמיה/ח׳</th>
              {hasDates && <th style={{ ...th, textAlign: "center" }}>תקופה</th>}
            </tr>
          </thead>
          <tbody>
            {kisuim.map((k, i) => (
              <tr key={k.covCode || i}>
                <td style={td()}>
                  <div style={{ fontWeight: 600 }}>{k.name || `כיסוי ${i + 1}`}</div>
                  {k.covCode && <div style={{ fontSize: 10, color: "#94a3b8" }}>{k.covCode}</div>}
                </td>
                <td style={{ ...td(), textAlign: "center" }}>
                  {k.statusLabel === "מסולק"
                    ? <span style={{ fontSize: 10, background: "#fef9c3", color: "#92400e", padding: "1px 7px", borderRadius: 8, fontWeight: 700 }}>מסולק</span>
                    : <span style={{ fontSize: 10, background: "#dcfce7", color: "#166534", padding: "1px 7px", borderRadius: 8, fontWeight: 700 }}>פעיל</span>
                  }
                </td>
                {hasValues && (
                  <td style={{ ...td(), textAlign: "left", fontWeight: 600, color: "#e11d48" }}>
                    {k.value > 0 ? fmtMoney(k.value) : <span style={{ color: "#cbd5e1" }}>—</span>}
                  </td>
                )}
                <td style={{ ...td(), textAlign: "left", fontWeight: 600, color: cs.accent }}>
                  {k.premiumMonthly > 0 ? fmtMoney(k.premiumMonthly) : <span style={{ color: "#cbd5e1" }}>—</span>}
                </td>
                {hasDates && (
                  <td style={{ ...td(), textAlign: "center", fontSize: 11, color: "#475569", whiteSpace: "nowrap" }}>
                    {k.startDate && k.endDate
                      ? `${k.startDate} – ${k.endDate}`
                      : k.startDate || k.endDate || "—"}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
          {totalMonthly > 0 && (
            <tfoot>
              <tr>
                <td colSpan={hasValues ? (hasDates ? 2 : 2) : (hasDates ? 2 : 2)}
                  style={{ padding: "6px 10px", fontSize: 11, color: "#64748b", borderTop: "2px solid #e2e8f0" }}>
                  סה״כ
                </td>
                {hasValues && <td style={{ padding: "6px 10px", borderTop: "2px solid #e2e8f0" }} />}
                <td style={{ padding: "6px 10px", textAlign: "left", fontWeight: 700, fontSize: 13, color: cs.accent, borderTop: "2px solid #e2e8f0" }}>
                  {fmtMoney(totalMonthly)}
                </td>
                {hasDates && <td style={{ borderTop: "2px solid #e2e8f0" }} />}
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
}
